import React, { useRef } from 'react';
import './brand.css';
import { react, javascript, htmlcss, html5, node, mongodb } from './imports';
import useOnScreen from './useOnScreen';
import styled, { css, keyframes } from 'styled-components';

const Brand = () => {
  const ref = useRef();
  const visible = useOnScreen(ref);

  return (
    <div className="gtp3__brand section__padding" id="features">
      <h3>Tools And Skills</h3>
      <Anime
        ref={ref}
        className="gtp3__brand-skills slide-fwd-center"
        visible={visible}
      >
        <img src={javascript} alt="javascript" />
        <img src={react} alt="react" />
        <img src={htmlcss} alt="htmlcss" />
        <img src={html5} alt="html5" />
        <img src={node} alt="node" />
        <img src={mongodb} alt="mongodb" />
      </Anime>
    </div>
  );
};
const animation = keyframes`

  from {
    transform:perspective(300px) translateZ(0);
  }

  to {
    transform:perspective(300px) translateZ(50px);
  }
      `;
const animation2 = keyframes`

  from {
    transform:perspective(300px) translateZ(50px);
  }

  to {
    transform:perspective(300px) translateZ(0);
  }
      `;

const Anime = styled.div`
  ${(props) =>
    props.visible
      ? css`
          animation: ${animation} 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        `
      : css`
          animation: ${animation2} 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        `}
`;
export default Brand;
